export default __webpack_public_path__ + "static/whowatch_soundlogo-b8f637ab7d05ad8d9cc4b538e06e4355.webm";